import './index.scss';
import React, { useEffect } from 'react';
import PlanDescription from './cancel-offer-plan-description';
import PricingLevel from './cancel-offer-pricing-level';

interface OfferPlanInfo {
  formattedOriginalPrice: string;
  formattedDiscountedPrice: string;
  features: string[];
}

interface CurrentPlanInfo {
  name: string;
}

interface CustomerCancelOfferProps {
  offerPlanInfo: OfferPlanInfo;
  currentPlanInfo: CurrentPlanInfo;
  // Props that will be passed through to child components
  [key: string]: any;
}

const CustomerCancelOffer: React.FC<CustomerCancelOfferProps> = (props) => {
  useEffect(() => {
    // Note: Logger tracking removed during TypeScript conversion
    // Original: Logger.track('CustomerCancelOffer.load');
  }, []);

  const headerText = (
    <div className="m-customer-cancel-offer--header-text text-center">
      <h1>Wait. Before you leave...</h1>
      <h2 className="subheader-text">
        Canceling your account will prevent you from accessing some of our
        greatest features
      </h2>
    </div>
  );

  const mainContent = (
    <div className="m-customer-cancel-offer--main-content">
      <PlanDescription {...props} />
      <PricingLevel {...props} />
    </div>
  );

  return (
    <div className="m-customer-cancel-offer">
      {headerText}
      {mainContent}
    </div>
  );
};

export default CustomerCancelOffer;
